import React, { useState } from "react";
import {
  ChatWrapper,
  FloatingButton,
  Overlay,
  ChatWindow,
  Header,
  MessagesArea,
  MessageBlock,
  MetaLine,
  Bubble,
  BotText,
  UserText,
  ImageWrap,
  BotImage,
  TypingIndicator,
  InputForm,
  TextInput,
  SendButton,
} from "./styledComponents";

const extractImageNamesFromText = (text) => {
  if (!text) return [];

  const matches = text.match(
    /^[-*]\s*\[([^\]]+\.(?:png|jpg|jpeg|gif|webp|svg))\]\s*$/gmi
  );

  if (!matches) return [];

  return matches
    .map((line) => line.replace(/^[-*]\s*\[|\]\s*$/g, "").trim())
    .filter(Boolean);
};

const removeImageLinesFromText = (text) => {
  if (!text) return text;

  return text
    .replace(
      /^[-*]\s*\[[^\]]+\.(?:png|jpg|jpeg|gif|webp|svg)\]\s*$/gmi,
      ""
    )
    .trim();
};

export default function SAVChatBot({
  apiUrl = "https://0ae3yc6xzh.execute-api.eu-west-3.amazonaws.com/api/chat",
  imgBasePath = "/imageSAV",
}) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Bonjour, posez votre probléme SAV lié au simulateur.",
      images: [],
    },
  ]);

  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const sendToChatAPI = async (userText) => {
    const res = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: userText }),
    });

    if (!res.ok) {
      const errorText = await res.text().catch(() => "<no body>");
      console.error("Réponse du back error :", res.status, errorText);
      throw new Error("Chat API error");
    }

    const outer = await res.json();

    let payload = outer;

    if (payload && typeof payload === "object" && typeof payload.body === "string") {
      try {
        payload = JSON.parse(payload.body);
      } catch {
        payload = { answer: payload.body };
      }
    }

    if (payload && typeof payload.answer === "string") {
      const s = payload.answer.trim();

      if (s.startsWith("{") && s.endsWith("}")) {
        try {
          const inner = JSON.parse(s);

          if (inner && typeof inner === "object") {
            payload = {
              ...payload,
              answer:
                typeof inner.answer === "string"
                  ? inner.answer
                  : payload.answer,
              images: Array.isArray(inner.images)
                ? inner.images
                : payload.images,
            };
          }
        } catch {}
      }
    }

    const answerText = typeof payload.answer === "string" ? payload.answer : "";
    const imagesFromJson = Array.isArray(payload.images) ? payload.images : [];

    const normalizedAnswer = answerText.replace(/\\n/g, "\n");

    const imagesFromText = extractImageNamesFromText(normalizedAnswer);

    const mergedImages = Array.from(
      new Set([...imagesFromJson, ...imagesFromText])
    );

    const cleanedAnswer = removeImageLinesFromText(normalizedAnswer);

    return {
      answer: cleanedAnswer,
      images: mergedImages,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmed = input.trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { from: "user", text: trimmed, images: [] }]);

    setInput("");
    setIsTyping(true);

    try {
      const { answer, images } = await sendToChatAPI(trimmed);

      setMessages((prev) => [...prev, { from: "bot", text: answer, images }]);
    } catch (err) {
      console.error(err);

      setMessages((prev) => [
        ...prev,
        {
          from: "bot",
          text: "Erreur de communication avec le serveur. Réessayez.",
          images: [],
        },
      ]);
    } finally {
      setIsTyping(false);
    }
  };

  const renderBotContent = (text, images) => (
    <>
      <BotText>{text}</BotText>

      {Array.isArray(images) &&
        images.map((imgName) => {
          const base = (imgBasePath || "").replace(/\/$/, "");
          const name = String(imgName || "").replace(/^\//, "");
          const src = `${base}/${name}`;

          return (
            <ImageWrap key={imgName}>
              <BotImage
                src={src}
                alt={imgName}
                onError={() => console.error("Image not found:", src)}
              />
            </ImageWrap>
          );
        })}
    </>
  );

  return (
    <>
      {isChatOpen && <Overlay onClick={() => setIsChatOpen(false)} />}

<ChatWrapper>
  {isChatOpen && (
    <ChatWindow>
      <Header>Support simulateur</Header>

      <MessagesArea>
        {messages.map((m, index) => (
          <MessageBlock key={index} $from={m.from}>
            <MetaLine $from={m.from}>{m.from === "user" ? "Vous" : "Bot"}</MetaLine>

            <Bubble $from={m.from}>
              {m.from === "bot" 
                ? renderBotContent(m.text, m.images)
                : <UserText>{m.text}</UserText>}
            </Bubble>
          </MessageBlock>
        ))}

        {isTyping && <TypingIndicator>Le bot écrit…</TypingIndicator>}
      </MessagesArea>

      <InputForm onSubmit={handleSubmit}>
        <TextInput
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Décrivez votre problème…"
        />
        <SendButton type="submit">Envoyer</SendButton>
      </InputForm>
    </ChatWindow>
  )}

  <FloatingButton onClick={() => setIsChatOpen(v => !v)}>
    {isChatOpen ? "×" : "💬"}
  </FloatingButton>
</ChatWrapper>
    </>
  );
}